import React, { useState } from "react";
import { getFirestore, collection, orderBy, getDocs, limit, query, setDoc, doc } from "firebase/firestore";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

function AddMateriales() {
    const [state, setState] = useState({
        name: '',
        codigos: '',
        description: '',
        visible: true,
        submitted: false,
        spinner: false,
    });

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const saveMaterialFirestore = async () => {
        const firestore = getFirestore();

        try {
            setState(prevState => ({ ...prevState, spinner: true }));
            const materialesCollectionRef = collection(firestore, "materiales");

            const q = query(materialesCollectionRef, orderBy("id", "desc"), limit(1));
            const querySnapshot = await getDocs(q);

            let lastId = 0;

            if (!querySnapshot.empty) {
                querySnapshot.forEach((doc) => {
                    lastId = doc.data().id;
                });
            }

            const newId = lastId + 1;

            const newMaterialData = {
                name: state.name,
                codigos: state.codigos,
                description: state.description,
                visible: state.visible,
                id: newId,
            };

            await setDoc(doc(firestore, "materiales", newId.toString()), newMaterialData);
            setState(
                prevState => ({
                    ...prevState,
                    submitted: true,
                    spinner: false
                }));

            console.log("Nuevo material guardado con éxito");
        } catch (error) {
            console.error("Error al guardar el material: ", error);
            setState(prevState => ({ ...prevState, spinner: false }));
        }
    };

    return (
        <Container component="main" maxWidth="md">
            {state.submitted ? (
                <div>
                    <Typography variant="h4">Material creado correctamente!</Typography>
                    <Button href="/materiales">
                        Ir a listado
                    </Button>
                </div>
            ) : (
                <div className="form-container">
                    {state.spinner ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Typography component="h1" variant="h5">
                                Nuevo Material
                            </Typography>
                            <div className="order-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="name"
                                            label="Nombre"
                                            value={state.name}
                                            name="name"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="codigos"
                                            label="Códigos (separados por coma)"
                                            value={state.codigos}
                                            name="codigos"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            className="default__textfield"
                                            id="description"
                                            label="Descripción"
                                            value={state.description}
                                            name="description"
                                            onChange={onChangeValues}
                                            multiline
                                            rows={4}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={state.visible}
                                                    onChange={(e) => setState(prev => ({ ...prev, visible: e.target.checked }))}
                                                    color="primary"
                                                />
                                            }
                                            label="Visible"
                                        />
                                    </Grid>
                                </Grid>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="button__save"
                                    onClick={saveMaterialFirestore}
                                >
                                    Aceptar
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Container>
    );
}

export default AddMateriales;
